import BasePage from "../../BasePage";
import React, { useState } from "react";
import { Skeleton, styled, Tab, Tabs } from "@mui/material";
import { Grid } from "@mui/material";
import Button from "../../../components/buttons/PrimaryButton";
import OutlinedButton from "../../../components/buttons/OutlinedButton";
import { useDispatch, useSelector } from "react-redux";
import {
  actions as routeActions,
  types as routes,
} from "../../../reducers/rotas.actions";
import FormCliente from "../tabs/FormCliente";
import FormDocumentosCliente from "../tabs/FormDocumentosCliente";
import ClientesPage from "../tabs/subestipulante/ClientesPage.connected";
import { useEffect } from "react";
import { getPayload } from "../../../selectors/routes.selectors";
import { actions } from "../../../reducers/cliente.actions";

const StyledH1 = styled("h1")`
  font-family: ${({ theme }) => theme.fonts.family.title};
  color: ${({ theme }) => theme.colors.blueTitle};
  font-weight: 400;
  letter-spacing: 4.8px;
  font-size: 45px;
  margin-bottom: -30px;
  @media (max-width: 900px) {
    font-size: 22px;
    margin-bottom: 10px;
  }
`;

const StyledContainer = styled(Grid)`
  margin-top: 10px;
  padding-left: 25px;
  padding-right: 20px;
  @media (max-width: 900px) {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

const StyledGrid = styled(Grid)`
  padding: 5px !important;

  .MuiGrid-item {
    padding-top: 5px;
  }
`;

const StyledSkeleton = styled(Skeleton)`
  width: 100%;
  height: 500px;
  margin-bottom: -65px;
`;

const StyledTab = styled(Tabs)`
  font-family: ${({ theme }) => theme.fonts.family.subTitle};
  & .Mui-selected {
    color: ${({ theme }) => theme.buttons.primary.background};
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

const StyledTabLabel = styled(Tab)`
  align-items: flex-start;
  min-width: 33%;
  font-family: ${({ theme }) => theme.fonts.family.subTitle};
  color: gray;
  font-weight: bold;
  text-transform: none;
  margin-bottom: -60px;
  font-size: 16px;
`;

const FormClientePage = ({
  loading,
  formProps,
  isFile,
  setIsFile,
  isFileImplantacao,
  setIsFileImplantacao,
  file,
  setFile,
  fileImplantacao,
  setFileImplantacao,
  editFile,
  editFileImplantacao,
  setEditFile,
  setEditFileImplantacao,
  handleDownloadArtefato,
  handleSubmit,
  subestipulante,
  isFileOD,
  fileOD,
  setFileOD,
  setIsFileOD,
  arrayFileOD,
  setArrayFileOD,
  disabled,
  data,
}) => {
  const [value, setValue] = useState(0);
  const { tab, isSubestipulante } = useSelector(getPayload);

  const dispatch = useDispatch();

  useEffect(() => {
    if (tab !== undefined) {
      setValue(tab);
    }
  }, [tab]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleClickVoltar = () => {
    if (isSubestipulante) {
      dispatch(
        actions.mostrarCliente.request({
          id: data?.clienteMatriz ?? subestipulante,
        })
      );
      dispatch(
        routeActions.redirectTo(routes.EDIT_CLIENTE, {
          id: data?.clienteMatriz ?? subestipulante,
          tab: 0,
        })
      );

      setValue(0);
    } else {
      dispatch(routeActions.redirectTo(routes.CLIENTES));
    }
  };

  if (loading) {
    return (
      <BasePage isLoggedIn={true} isLightBlue={true}>
        <StyledSkeleton />
      </BasePage>
    );
  }

  return (
    <form onSubmit={formProps.handleSubmit(handleSubmit)}>
      <BasePage isLoggedIn={true} isLightBlue={true}>
        <StyledContainer container spacing={2}>
          <Grid item xs={12}>
            <StyledH1>
              {value === 0
                ? "Editar Cliente"
                : value === 1
                ? "Lista Sub-Estipulantes"
                : "Documentos"}
            </StyledH1>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ marginTop: "10px", marginBottom: "10px" }}
          >
            <StyledTab
              sx={{ marginBottom: "10px" }}
              value={value}
              onChange={handleChange}
              TabIndicatorProps={{
                style: {
                  background: "#F24F13",
                  color: "#F24F13",
                  minHeight: "6px",
                  marginRight: "20px",
                  borderRadius: "5px",
                },
              }}
              textColor={"inherit"}
            >
              <StyledTabLabel label="Dados do Cliente" />
              <StyledTabLabel label="Dados Sub-Estipulantes" />
              <StyledTabLabel label="Documentos" />
            </StyledTab>
          </Grid>
        </StyledContainer>
        <StyledContainer container spacing={2}>
          {value === 0 && (
            <FormCliente
              loading={loading}
              formProps={formProps}
              disabled={disabled}
            />
          )}
          {value === 1 && <ClientesPage />}
          {value === 2 && (
            <FormDocumentosCliente
              loading={loading}
              formProps={formProps}
              isFile={isFile}
              setIsFile={setIsFile}
              isFileImplantacao={isFileImplantacao}
              setIsFileImplantacao={setIsFileImplantacao}
              file={file}
              setFile={setFile}
              fileImplantacao={fileImplantacao}
              setFileImplantacao={setFileImplantacao}
              editFile={editFile}
              editFileImplantacao={editFileImplantacao}
              setEditFile={setEditFile}
              setEditFileImplantacao={setEditFileImplantacao}
              handleDownloadArtefato={handleDownloadArtefato}
              isFileOD={isFileOD}
              setIsFileOD={setIsFileOD}
              fileOD={fileOD}
              setFileOD={setFileOD}
              arrayFileOD={arrayFileOD}
              setArrayFileOD={setArrayFileOD}
            />
          )}
        </StyledContainer>
        <StyledContainer
          container
          spacing={2}
          style={{ display: "flex", justifyContent: "Center" }}
        >
          <StyledGrid item xs={4}>
            <OutlinedButton onClick={handleClickVoltar}>Voltar</OutlinedButton>
          </StyledGrid>
          <StyledGrid item xs={4}>
            <Button type={"submit"} loading={loading} disabled={disabled}>
              Confirmar
            </Button>
          </StyledGrid>
        </StyledContainer>
      </BasePage>
    </form>
  );
};

export default FormClientePage;
